import IssueDataSection from "./IssueDataSection";

export default IssueDataSection;
